import component from "./ProfileAlerts.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileAlerts"

export default wrapVueComponent(componentName, component)
